<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          class="py-6 px-md-6"
          v-for="(item, i) in categories"
          :key="i"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>

          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catDBusiness",
  components: { CatCard },
  data: () => ({
    serviceName: "Qrland",
    componentName: "catDBusiness",
    helpData: [],

    categories: [
      {
        name: "بیزینس پیج",
        value: "",
        route: "qr.create.businessPage",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-account-tie-outline",
        isTest: false,
      },
      {
        name: "نوبت دهی",
        value: "",
        route: "qr.link",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-ticket-confirmation",
        comingSoon: true,
      },
      {
        name: "فروش محصول",
        value: "",
        route: "qr.notebook",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-package-variant-closed-check",
        comingSoon: true,
      },
      {
        name: "فرم استخدام",
        value: "",
        route: "qr.link",
        colors: ["#e43a15", "#e65245", "#e43a15"],
        icon: "mdi-list-box-outline",
        comingSoon: true,
      },
      {
        name: "فروش محصولات توسط نمایندگان",
        value: "",
        route: "qr.link",
        colors: ["#2c3e50", "#2980b9", "#2c3e50"],
        icon: "mdi-store-marker",
        comingSoon: true,
      },
      {
        name: "فرم سازمانی",
        value: "",
        route: "qr.link",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-form-textarea",
        comingSoon: true,
      },
      
      {
        name: "فروش محصولات توسط مارکت های طرف قرارداد",
        value: "",
        route: "qr.link",
        colors: ["#6a3093", "#a044ff", "#6a3093"],
        icon: "mdi-assistant",
        comingSoon: true,
      },
      {
        name: "کارت پرسنلی",
        value: "",
        route: "qr.link",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-card-account-phone-outline",
        comingSoon: true,
      },
      {
        name: "منو غذا",
        value: "",
        route: "qr.menu",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-silverware",
        comingSoon: true,
      },
    ],
  }),
};
</script>

<style scoped></style>
